import React, {useContext} from "react"
import {Panel, DataRow} from "../PDFPrimitives"
import {PDFContext} from "../BasePDF"

export const CapitalizedCostBreakdownPDF = ({isCustomerWorksheet}) => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    // Optional rows — only render when the value is present and non-zero.
    const extras = [
        ['Dealer Incentive',             pdfData.dealer_incentive],
        ['Inception Fees (Capitalized)', pdfData.inception_fees_capitalized],
        ['Cash as Cap Reduction',        pdfData.cap_reduction_cash],
        ['Rebate as Cap Reduction',      pdfData.rebate_as_cap_reduction],
        ['Trade as Cap Reduction',       pdfData.trade_as_cap_reduction],
        ['Negative Trade Equity',        pdfData.trade_as_negative_equity],
    ].filter(([, v]) => v && v !== '0')

    const breakdownRows = (pdfData.cap_cost_breakdown || [])
        .filter((v) => v.amount !== '0' && v.amount !== '0.0')

    return (
        <Panel title="Capitalized Cost Breakdown">
            {!isCustomerWorksheet && (
                <>
                    <DataRow label="Vehicle Cost" value={pdfData.vehicle_cost.toDollarFormat()}/>
                    <DataRow label="Profit"       value={pdfData.profit.toDollarFormat()} variant="muted"/>
                </>
            )}
            <DataRow
                label="Selling Price"
                value={pdfData.selling_price.toDollarFormat()}
                isTotal
                variant="bold"
            />
            {extras.map(([label, value]) => (
                <DataRow key={label} label={label} value={value.toDollarFormat()}/>
            ))}
            {breakdownRows.map((v) => (
                <DataRow key={`${v.name}-${v.amount}`} label={v.name} value={v.amount.toDollarFormat()}/>
            ))}
            <DataRow
                label="Total Capital Cost"
                value={pdfData.total_capital_cost.toDollarFormat()}
                isTotal
                variant="bold"
                isLast
            />
        </Panel>
    )
}
